import type { InboxDemoData } from "./types";

export const defaultDemo: InboxDemoData = {
  navigation: {
    title: "Inbox",
    notificationCount: 5,
    userName: "Peter",
    userAvatar: "/images/inbox-demo/avatar/avatar21.png",
    planBadge: "PRO",
  },
  selectedGroupId: "all",
  groups: [
    { id: "all", label: "📬 全部消息" },
    { id: "ai", label: "🤖 AI 处理中", showCount: true },
    { id: "pending", label: "👤 待人工接入", showCount: true },
    { id: "mine", label: "🙋 我负责的", showCount: true },
    { id: "closed", label: "✅ 已关闭" },
    {
      id: "channels",
      label: "渠道",
      collapsible: true,
      defaultExpanded: true,
      children: [
        {
          id: "wechat",
          label: "微信",
          iconKey: "wechat",
          collapsible: true,
          defaultExpanded: true,
          children: [
            { id: "conv-chen-yuhang", label: "陈宇航" },
            { id: "conv-wang-siqi", label: "王思琪" },
            { id: "conv-zhao-chenxi", label: "赵晨曦" },
          ],
        },
        {
          id: "wecom",
          label: "企业微信",
          iconKey: "wecom",
          collapsible: true,
          defaultExpanded: false,
          children: [
            { id: "conv-zhou-kexin", label: "周可欣" },
            { id: "conv-sato-kenichi", label: "佐藤健一" },
          ],
        },
        {
          id: "xiaohongshu",
          label: "小红书",
          iconKey: "xiaohongshu",
          collapsible: true,
          defaultExpanded: false,
          children: [{ id: "conv-lin-xiaoyu", label: "林晓雨" }],
        },
        {
          id: "tiktok",
          label: "抖音",
          iconKey: "tiktok",
          collapsible: true,
          defaultExpanded: false,
          children: [
            { id: "conv-sophie-chen", label: "Sophie Chen" },
            { id: "conv-nguyen-minh-anh", label: "Nguyễn Minh Anh" },
          ],
        },
        {
          id: "email",
          label: "邮箱",
          iconKey: "email",
          collapsible: true,
          defaultExpanded: false,
          children: [{ id: "conv-alex-morgan", label: "Alex Morgan" }],
        },
        {
          id: "api",
          label: "开放接口",
          iconKey: "api",
          collapsible: true,
          defaultExpanded: false,
          children: [{ id: "conv-michael-tan", label: "Michael Tan" }],
        },
      ],
    },
  ],
  conversations: [
    {
      id: "conv-lin-xiaoyu",
      name: "林晓雨",
      avatar: "/images/inbox-demo/avatar/avatar18.png",
      avatarInitial: "林",
      avatarTone: "primary",
      preview: "M 码衣长约 103cm。米白色 M 码目前有货，可以正常下单 😊",
      timestamp: "14:04",
      channel: "小红书",
      channelKey: "xiaohongshu",
      status: "ai",
      messages: [
        {
          id: "c1-m1",
          sender: "customer",
          senderName: "林晓雨",
          content: "这件羊毛衫 160 穿 S 还是 M？\n我平时里面还会穿短袖和衬衫打底",
          timestamp: "14:02",
          dateLabel: "Today  14:02",
        },
        {
          id: "c1-m2",
          sender: "customer",
          senderName: "林晓雨",
          content: "还有米白色会不会比较透啊 😂",
          timestamp: "14:02",
        },
        {
          id: "c1-m3",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "如果您身高 160cm，里面还会内搭两件衣物，我更建议 M 码，活动空间会舒服一些。\n\n米白色这款有内衬，正常穿着不会透。\n如果比较在意显瘦，黑色会更合适；想要秋冬搭配更柔和，可以选米白色。",
          timestamp: "14:03",
          executionTrace: [
            {
              icon: "bookOpenText",
              title: "读取配置",
              bullets: [
                "`default_lang`：默认语言",
                "`default_lang_source`：是否优先使用访客语言",
                "`service_languages`：Agent 支持的语言范围",
                "`contact_lang`：访客资料中的语言",
              ],
            },
            {
              icon: "fileSearchCorner",
              title: "识别用户本轮语言",
              bullets: [
                "代码规则判断：中文、空消息、短确认词、型号、链接等直接处理。",
                "模型判断：其余文本调用 `OPENAI_GPT_5_4_MODEL` 识别语言。",
                "图片和文件内容不参与语言识别。",
              ],
            },
            {
              icon: "circleCheck",
              title: "确定初始语言",
              code: "last_output_language",
            },
            {
              icon: "settings",
              title: "设置回复语言",
              detail: "简体中文",
            },
            {
              icon: "databaseSearch",
              title: "调用知识库",
              detail: "秋冬女装商品资料",
            },
            {
              icon: "databaseSearch",
              title: "调用知识库",
              detail: "服装尺码与穿搭指南",
            },
            {
              icon: "workflow",
              title: "执行任务",
              detail: "商品咨询与尺码推荐",
            },
            {
              icon: "messageCircleMore",
              title: "生成回答",
              note: "`last_output_language`写入系统 Prompt，要求主模型使用该语言回复。",
            },
          ],
        },
        {
          id: "c1-m4",
          sender: "customer",
          senderName: "林晓雨",
          content: "好，那 M 码衣长多少？米白现在有货吗？",
          timestamp: "14:03",
        },
        {
          id: "c1-m5",
          sender: "ai",
          senderName: "3Chat Agent",
          content: "M 码衣长约 65cm。米白色 M 码目前有货，可以正常下单 😊",
          timestamp: "14:04",
          executionTrace: [
            {
              icon: "databaseSearch",
              title: "调用知识库",
              detail: "秋冬女装商品资料",
            },
            {
              icon: "wrench",
              title: "触发调用工具",
              detail: "Shopify Inventory",
            },
            {
              icon: "search",
              title: "查询 SKU `WCT-M-IVORY` 实时库存",
            },
            {
              icon: "messageCircleMore",
              title: "生成回答",
              note: "查询 SKU `WCT-M-IVORY` 实时库存",
            },
          ],
        },
      ],
    },
    {
      id: "conv-nguyen-minh-anh",
      name: "Nguyễn Minh Anh",
      avatar: "/images/inbox-demo/avatar/avatar7.png",
      avatarInitial: "N",
      avatarTone: "warning",
      preview: "Đã xong ✓ Urban Runner · Trắng · EU 38 已加入购物车",
      timestamp: "20:10",
      channel: "抖音",
      channelKey: "tiktok",
      status: "ai",
      messages: [
        {
          id: "c10-m1",
          sender: "customer",
          senderName: "Nguyễn Minh Anh",
          content: "Chào bạn, mẫu giày này có ship đến Việt Nam không?",
          timestamp: "20:06",
          dateLabel: "Today  20:06",
        },
        {
          id: "c10-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Có 😊 Chúng tôi hỗ trợ giao hàng đến Việt Nam.\n\nBạn đang quan tâm đến mẫu Urban Runner vừa xem phải không?",
          timestamp: "20:06",
        },
        {
          id: "c10-m3",
          sender: "customer",
          senderName: "Nguyễn Minh Anh",
          content: "Đúng rồi\nMàu trắng size 38 còn không?",
          timestamp: "20:07",
        },
        {
          id: "c10-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Màu trắng size EU 38 hiện vẫn còn hàng.\n\nNếu giao đến Việt Nam, thời gian dự kiến khoảng 5-7 ngày làm việc.",
          timestamp: "20:07",
        },
        {
          id: "c10-m5",
          sender: "customer",
          senderName: "Nguyễn Minh Anh",
          content: "Tôi thường mang Nike 38\nMẫu này có cần tăng size không?",
          timestamp: "20:08",
        },
        {
          id: "c10-m6",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Urban Runner có form khá chuẩn nên nếu bạn thường mang Nike EU 38 thì mình khuyên chọn EU 38.\n\nNếu chân bạn hơi rộng, EU 39 sẽ thoải mái hơn một chút.",
          timestamp: "20:08",
        },
        {
          id: "c10-m7",
          sender: "customer",
          senderName: "Nguyễn Minh Anh",
          content: "38 nhé\nCó mã giảm giá nào không?",
          timestamp: "20:09",
        },
        {
          id: "c10-m8",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Có 🎉 Bạn là khách hàng mua lần đầu nên có thể sử dụng ưu đãi giảm 10% cho đơn hàng đầu tiên.\n\nMã giảm giá sẽ được áp dụng khi thanh toán.",
          timestamp: "20:09",
        },
        {
          id: "c10-m9",
          sender: "customer",
          senderName: "Nguyễn Minh Anh",
          content: "Ok, thêm size 38 vào giỏ hàng giúp tôi nhé",
          timestamp: "20:10",
        },
        {
          id: "c10-m10",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Đã xong ✓\n\nMình đã thêm Urban Runner · Trắng · EU 38 vào giỏ hàng và áp dụng ưu đãi 10%.\n\nBạn có thể kiểm tra thông tin giao hàng trước khi thanh toán.",
          timestamp: "20:10",
        },
      ],
    },
    {
      id: "conv-zhou-kexin",
      name: "周可欣",
      avatar: "/images/inbox-demo/avatar/avatar4.png",
      avatarInitial: "周",
      avatarTone: "secondary",
      preview: "那行，我去付款",
      timestamp: "19:17",
      channel: "企业微信",
      channelKey: "wecom",
      status: "ai",
      messages: [
        {
          id: "c6-m1",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "嗨，可欣 👋\n看到您刚刚在看 CloudSoft Pro 吹风机，购物车里的商品还没有结算。\n\n是还在考虑颜色，还是想再了解一下使用效果？",
          timestamp: "19:12",
          dateLabel: "Today  19:12",
        },
        {
          id: "c6-m2",
          sender: "customer",
          senderName: "周可欣",
          content: "哈哈被发现了\n主要不知道值不值得买",
          timestamp: "19:14",
        },
        {
          id: "c6-m3",
          sender: "ai",
          senderName: "3Chat Agent",
          content: "理解 😂 如果您比较在意吹干速度和减少毛躁，它会比较值得。",
          timestamp: "19:14",
        },
        {
          id: "c6-m4",
          sender: "customer",
          senderName: "周可欣",
          content: "我是长头发，而且染过，比较干\n今天买有优惠吗",
          timestamp: "19:15",
        },
        {
          id: "c6-m5",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "有 😊 您账户里还有一张 ¥80 新客优惠券可以使用，结算时会自动抵扣。",
          timestamp: "19:16",
        },
        {
          id: "c6-m6",
          sender: "customer",
          senderName: "周可欣",
          content: "那行，我去付款",
          timestamp: "19:17",
        },
      ],
    },
    {
      id: "conv-zhao-chenxi",
      name: "赵晨曦",
      avatar: "/images/inbox-demo/avatar/avatar15.png",
      avatarInitial: "赵",
      avatarTone: "cyan",
      preview: "好的，谢谢",
      timestamp: "17:33",
      channel: "微信",
      channelKey: "wechat",
      status: "mine",
      messages: [
        {
          id: "c9-m1",
          sender: "customer",
          senderName: "赵晨曦",
          content:
            "我上个月买的咖啡机今天突然不出咖啡了\n\n机器有声音\n但是按完之后只出一点点水",
          timestamp: "17:26",
          dateLabel: "Today  17:26",
        },
        {
          id: "c9-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "可以帮您一起排查。先确认两个情况：\n\n1. 水箱目前有水，并且已经安装到位吗？\n2. 屏幕上有没有显示错误代码或红色提示灯？",
          timestamp: "17:26",
        },
        {
          id: "c9-m3",
          sender: "customer",
          senderName: "赵晨曦",
          content: "水是满的\n没有错误代码\n\n刚才我又试了一次，还是只有一点水",
          timestamp: "17:27",
        },
        {
          id: "c9-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "了解。没有错误代码且水箱正常的话，比较可能是冲煮系统堵塞。\n\n您最近一次清洁或除垢大概是什么时候？",
          timestamp: "17:27",
        },
        {
          id: "c9-m5",
          sender: "customer",
          senderName: "赵晨曦",
          content: "买回来好像一次都没弄过 😅",
          timestamp: "17:28",
        },
        {
          id: "c9-m6",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "那我们可以先尝试一次自动清洁。我可以一步一步告诉您怎么操作，大约需要 5 分钟。\n\n如果清洁后仍无法正常出水，我再直接帮您申请售后，不需要重新描述问题。",
          timestamp: "17:28",
        },
        {
          id: "c9-m7",
          sender: "customer",
          senderName: "赵晨曦",
          content: "按照你说的清洁完了\n还是不行",
          timestamp: "17:31",
        },
        {
          id: "c9-m8",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "清洁后仍然无法正常出水，建议进一步检测。\n\n您的咖啡机目前还在保修期内，我已经帮您创建售后工单：\n\n工单号：AS-209831\n\n售后团队会根据您订单中的联系方式与您确认检测安排，不需要再次提交故障信息。",
          timestamp: "17:32",
        },
        {
          id: "c9-m9",
          sender: "customer",
          senderName: "赵晨曦",
          content: "好的，谢谢",
          timestamp: "17:33",
        },
      ],
    },
    {
      id: "conv-michael-tan",
      name: "Michael Tan",
      avatarInitial: "M",
      avatarTone: "primary",
      preview: "You're welcome! I'll keep the conversation open.",
      timestamp: "16:11",
      channel: "开放接口",
      channelKey: "api",
      status: "ai",
      messages: [
        {
          id: "c5-m1",
          sender: "customer",
          senderName: "Michael Tan",
          content: "Can I change the delivery address?\nIt hasn't arrived yet.",
          timestamp: "16:08",
          dateLabel: "Today  16:08",
        },
        {
          id: "c5-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Sure. Please send me your order number and I'll check whether the shipment can still be updated.",
          timestamp: "16:08",
        },
        {
          id: "c5-m3",
          sender: "customer",
          senderName: "Michael Tan",
          content: "SG-582913",
          timestamp: "16:09",
        },
        {
          id: "c5-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "I found your order. It hasn't gone out for delivery yet, so the address can still be changed.\n\nWhat's the new address?",
          timestamp: "16:09",
        },
        {
          id: "c5-m5",
          sender: "customer",
          senderName: "Michael Tan",
          content: "18 Marina Boulevard, #12-03\nSingapore 018980",
          timestamp: "16:10",
        },
        {
          id: "c5-m6",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "✅ Delivery address updated\n\nNew address:\n18 Marina Boulevard, #12-03\nSingapore 018980\n\nYour estimated delivery date remains Sep 8.",
          timestamp: "16:11",
        },
        {
          id: "c5-m7",
          sender: "customer",
          senderName: "Michael Tan",
          content: "Perfect thanks!",
          timestamp: "16:11",
        },
        {
          id: "c5-m8",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "You're welcome! I'll keep the conversation open in case there are any delivery updates.",
          timestamp: "16:11",
        },
      ],
    },
    {
      id: "conv-sophie-chen",
      name: "Sophie Chen",
      avatar: "/images/inbox-demo/avatar/avatar2.png",
      avatarInitial: "S",
      avatarTone: "secondary",
      preview: "夹克目前是 ¥899。裤子也是同系列 Wide-Leg Tailored Trousers。",
      timestamp: "15:32",
      channel: "抖音",
      channelKey: "tiktok",
      status: "ai",
      messages: [
        {
          id: "c3-m1",
          sender: "customer",
          senderName: "Sophie Chen",
          content:
            "📷 [图片：模特穿棕色短款皮夹克]\n这件是你们家的吗？我在 Instagram 看到的",
          timestamp: "15:31",
          dateLabel: "Today  15:31",
        },
        {
          id: "c3-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "是的 😊 图片里是我们的 Autumn Essential Cropped Leather Jacket，棕色款。\n\n您是想了解尺码，还是现在的价格？",
          timestamp: "15:31",
        },
        {
          id: "c3-m3",
          sender: "customer",
          senderName: "Sophie Chen",
          content: "价格，还有图片这个女生下面搭的裤子也有吗",
          timestamp: "15:32",
        },
        {
          id: "c3-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "夹克目前是 ¥899。\n\n图片里的裤子也是我们同系列的 Wide-Leg Tailored Trousers，两件一起就是图片里的完整 Look。",
          timestamp: "15:32",
        },
      ],
    },
    {
      id: "conv-sato-kenichi",
      name: "佐藤健一",
      avatar: "/images/inbox-demo/avatar/avatar13.png",
      avatarInitial: "佐",
      avatarTone: "default",
      preview: "法人信息已注册，Model X27 × 30台的报价正在创建。",
      timestamp: "13:11",
      channel: "企业微信",
      channelKey: "wecom",
      status: "ai",
      messages: [
        {
          id: "c8-m1",
          sender: "customer",
          senderName: "佐藤健一",
          content:
            "会社用に御社のモニターを30台ほど購入したいのですが、法人価格はありますか？",
          timestamp: "13:06",
          dateLabel: "Today  13:06",
        },
        {
          id: "c8-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "はい。30台のご購入の場合、法人向けボリュームディスカウントの対象になります。",
          timestamp: "13:06",
        },
        {
          id: "c8-m3",
          sender: "customer",
          senderName: "佐藤健一",
          content: "Model X27を検討しています。\n保証は通常購入と同じですか？",
          timestamp: "13:07",
        },
        {
          id: "c8-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Model X27を30台ご購入の場合、法人向けに3年間の製品保証が適用されます。",
          timestamp: "13:08",
        },
        {
          id: "c8-m5",
          sender: "customer",
          senderName: "佐藤健一",
          content: "見積書を先にもらえますか？",
          timestamp: "13:09",
        },
        {
          id: "c8-m6",
          sender: "ai",
          senderName: "3Chat Agent",
          content: "もちろんです。会社名と担当者メールアドレスをお願いします。",
          timestamp: "13:09",
        },
        {
          id: "c8-m7",
          sender: "customer",
          senderName: "佐藤健一",
          content: "株式会社青空商事\nkenichi.sato@example.jp",
          timestamp: "13:10",
        },
        {
          id: "c8-m8",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "ありがとうございます。法人情報を登録し、Model X27 × 30台の見積書作成を開始しました。",
          timestamp: "13:11",
        },
      ],
    },
    {
      id: "conv-wang-siqi",
      name: "王思琪",
      avatar: "/images/inbox-demo/avatar/avatar14.png",
      avatarInitial: "王",
      avatarTone: "cyan",
      preview: "按 ANA 随身行李尺寸要求，这款尺寸在允许范围内。",
      timestamp: "11:49",
      channel: "微信",
      channelKey: "wechat",
      status: "ai",
      messages: [
        {
          id: "c4-m1",
          sender: "customer",
          senderName: "王思琪",
          content:
            "🎙️ 语音 0:18\n我下周五要去日本，然后想买你们那个黑色登机箱，不知道现在买来不来得及，我人在杭州。",
          timestamp: "11:46",
          dateLabel: "Today  11:46",
        },
        {
          id: "c4-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "可以的。黑色 20\" Carry-On 目前杭州仓有现货，正常预计 1-2 天送达，时间上来得及。",
          timestamp: "11:47",
        },
        {
          id: "c4-m3",
          sender: "customer",
          senderName: "王思琪",
          content: "ANA 可以直接登机吗？不想托运",
          timestamp: "11:47",
        },
        {
          id: "c4-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "按 ANA 的随身行李尺寸要求，这款尺寸在允许范围内。\n\n您下周就要出发，如果确定购买，建议这两天完成下单，避免临近出发遇到物流延迟。",
          timestamp: "11:49",
        },
      ],
    },
    {
      id: "conv-chen-yuhang",
      name: "陈宇航",
      avatar: "/images/inbox-demo/avatar/avatar3.png",
      avatarInitial: "陈",
      avatarTone: "danger",
      preview: "您好，我是 Peter，已经看到前面的记录了。",
      timestamp: "10:24",
      channel: "微信",
      channelKey: "wechat",
      status: "pending",
      messages: [
        {
          id: "c2-m1",
          sender: "customer",
          senderName: "陈宇航",
          content: "我的退款已经一个星期了，为什么还没到账？",
          timestamp: "10:21",
          dateLabel: "Today  10:21",
        },
        {
          id: "c2-m2",
          sender: "ai",
          senderName: "3Chat Agent",
          content: "我来帮您查一下，可以把订单号发给我吗？",
          timestamp: "10:21",
        },
        {
          id: "c2-m3",
          sender: "customer",
          senderName: "陈宇航",
          content: "CN202609013821\n上周一就显示退款成功了",
          timestamp: "10:22",
        },
        {
          id: "c2-m4",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "查到了。该订单退款金额为 ¥1,299，系统显示退款已于 9 月 1 日提交至原支付渠道。\n\n正常情况下银行卡退款需要 3-7 个工作日。",
          timestamp: "10:22",
        },
        {
          id: "c2-m5",
          sender: "customer",
          senderName: "陈宇航",
          content: "今天已经第七天了\n银行卡也确认没有",
          timestamp: "10:23",
        },
        {
          id: "c2-m6",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "这笔退款已经达到预计处理时限，我帮您转给人工客服进一步核对。\n\n订单号、退款金额和当前进度已经同步，不需要重新说明。",
          timestamp: "10:23",
        },
        {
          id: "c2-m7",
          sender: "human",
          senderName: "Peter",
          content: "您好，我是 Peter，已经看到前面的记录了。我现在帮您继续核对。",
          timestamp: "10:24",
        },
      ],
    },
    {
      id: "conv-alex-morgan",
      name: "Alex Morgan",
      avatarInitial: "A",
      avatarTone: "success",
      preview: "Amazing, thanks",
      timestamp: "09:41",
      channel: "邮箱",
      channelKey: "email",
      status: "mine",
      messages: [
        {
          id: "c7-m1",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Hi Alex, looks like it's been about 8 weeks since your last order of Daily Roast No. 3.\n\nRunning low? ☕",
          timestamp: "09:35",
          dateLabel: "Today  09:35",
        },
        {
          id: "c7-m2",
          sender: "customer",
          senderName: "Alex Morgan",
          content: "Actually yes lol\nWas going to order this week",
          timestamp: "09:38",
        },
        {
          id: "c7-m3",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Perfect timing. Last time you ordered 2 × 1kg whole beans.\n\nWould you like the same order again?",
          timestamp: "09:38",
        },
        {
          id: "c7-m4",
          sender: "customer",
          senderName: "Alex Morgan",
          content: "Same beans but maybe 3 bags this time",
          timestamp: "09:39",
        },
        {
          id: "c7-m5",
          sender: "ai",
          senderName: "3Chat Agent",
          content:
            "Done ✓ I've added 3 × Daily Roast No. 3, 1kg whole beans to your cart.\n\nYour order also qualifies for free shipping.",
          timestamp: "09:40",
        },
        {
          id: "c7-m6",
          sender: "customer",
          senderName: "Alex Morgan",
          content: "Amazing, thanks",
          timestamp: "09:41",
        },
      ],
    },
  ],
};
